// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/blog/:slug*?\",\"regex\":\"^/blog(?:/(.*))?$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/docs/:slug*?\",\"regex\":\"^/docs(?:/(.*))?$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/research/:documentId\",\"regex\":\"^/research/([^/]+)$\",\"paramNames\":[\"documentId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/daytta\"},{\"path\":\"/desktop\"},{\"path\":\"/extract\"},{\"path\":\"/graph\"},{\"path\":\"/investors\"},{\"path\":\"/kautious\"},{\"path\":\"/kautious/ai-snapshot\"},{\"path\":\"/llamox\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"},{\"path\":\"/time\"},{\"path\":\"/agent\"},{\"path\":\"/assistant\"},{\"path\":\"/billing\"},{\"path\":\"/billing/success\"},{\"path\":\"/console\"},{\"path\":\"/debug\"},{\"path\":\"/hyperdx-test\"},{\"path\":\"/login\"},{\"path\":\"/logout\"},{\"path\":\"/sandbox\"},{\"path\":\"/sandbox/design\"},{\"path\":\"/settings\"},{\"path\":\"/workspace\"}],\"isrRoutes\":[\"/blog/:slug*?\",\"/docs/:slug*?\"]}";globalThis["_sentryNextJsVersion"] = "16.4.0";import * as Sentry from "@sentry/nextjs";

// Skip Sentry initialization in development
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.1,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    replaysOnErrorSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [
      Sentry.replayIntegration({
        // Additional Replay configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });
}

// Export the hook required for Sentry navigation instrumentation
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
